let api_url = null
api_url = process.env.VUE_APP_API
let language = 'pt'

export const axios = require('axios').create({
  baseURL: api_url
})
let getToken = () => {
  let tokenObj = sessionStorage.getItem('token')
  if (tokenObj) {
    let tokenJson = JSON.parse(tokenObj)
    if (tokenJson) return tokenJson.token;
  }
  return false
}
axios.interceptors.request.use(function (config) {
  const token = getToken()
  config.headers.Authorization =  'Bearer ' + token;
  return config;
});

// global API error handling
axios.interceptors.response.use(null, (err) => {
  return Promise.reject(err)
})

let api = {}
api.install = (Vue) => {
  Vue.prototype.api = {
    get: async (query = '') => {
      if (query.includes('?')) query += '&language=' + language
      else query += '?language=' + language
      let response = await axios({
        method: 'get',
        url: query
      })
      return response.data
    },
    post: (query = '', data) => axios.post(query,
      data
    ),
    put: (query = '', data) => axios.put(query,
      data
    ),
    post_multipart: (query = '', data) => axios.post(query, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }),
    delete: (query = '') => axios.delete(query)
  }
}
export default api